import { Component, signal, inject } from '@angular/core';
import { LoginService } from './login.service';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { focusById } from './focus';
import { AuthStoreService } from '../core/auth-store.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
})
export class LoginComponent {
  private readonly router = inject(Router);
  private readonly loginService = inject(LoginService);
  private readonly authStore = inject(AuthStoreService);
  email = signal('');
  password = signal('');
  remember = signal(false);
  submitting = signal(false);

  // per-field validation messages
  emailError = signal<string | null>(null);
  passwordError = signal<string | null>(null);

  private validate(): boolean {
    let valid = true;
    const e = this.email().trim();
    const p = this.password();

    // email basic check
    if (!e) {
      this.emailError.set('El correo es requerido');
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) {
      this.emailError.set('Introduzca un correo valido');
      valid = false;
    } else {
      this.emailError.set(null);
    }

    // password basic check
    if (!p) {
      this.passwordError.set('La contraseña es requerida');
      valid = false;
    } else if (p.length < 6) {
      this.passwordError.set('La contraseña debe tener al menos 6 caracteres');
      valid = false;
    } else {
      this.passwordError.set(null);
    }

    return valid;
  }

  submit() {
    this.submitting.set(false);
    // run validation first
    const ok = this.validate();
    if (!ok) {
      // focus the first invalid field for accessibility
      setTimeout(() => {
        if (this.emailError()) {
          focusById('email');
        } else if (this.passwordError()) {
          focusById('password');
        }
      }, 0);
      return;
    }

    this.submitting.set(true);
    const e = this.email().trim();
    const p = this.password();

    this.loginService
      .login(e, p, this.remember())
      .then((session) => {
        this.authStore.setSession(session);
        this.submitting.set(false);
        const role = session.user.role;
        if (role === 'organization_administrator') {
          this.router.navigate(['/questionnaires']);
          return;
        }

        this.router.navigate(['/dashboard/kyc']);
      })
      .catch((err: unknown) => {
        this.submitting.set(false);
        const message =
          typeof err === 'object' && err !== null && 'message' in err
            ? String((err as { message?: string }).message ?? 'Credenciales invalidas')
            : 'Credenciales invalidas';
        this.passwordError.set(message);
        setTimeout(() => focusById('password'), 0);
      });
  }
}
